import Vue from "vue";
import VueTheMask from "vue-the-mask";
import Toasted from "vue-toasted";
import Vuelidate from "vuelidate";
import appLink from "./apilink";
import { VueReCaptcha } from 'vue-recaptcha-v3'
import PerfectScrollbar from 'vue2-perfect-scrollbar'

import "moment/locale/uk";
import "moment/locale/ru";
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'

Vue.use(Toasted, {
  duration: 3000,
  position: "top-right",
});
Vue.use(PerfectScrollbar);
Vue.use(appLink);
Vue.use(VueTheMask);
Vue.use(Vuelidate);
Vue.use(require("vue-moment"));
Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_RECAPTCHA_KEY })

